function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import Flip from './Flip';
import FlipToggle from './FlipToggle';

var closeFlipByOutsideClick = function closeFlipByOutsideClick(flipNode, targetNode) {
  if (flipNode === targetNode) return;
  if (flipNode.contains(targetNode)) return;
  new Flip(flipNode).closeFlipOpenedToggles();
};

var getToggleAgent = function getToggleAgent(toggleNode) {
  var flipNode = toggleNode.closest('.flip');
  return new FlipToggle(toggleNode, new Flip(flipNode));
};

var openToggle = function openToggle(toggleNode) {
  return getToggleAgent(toggleNode).openToggle();
};

var toggleToggle = function toggleToggle(toggleNode) {
  return getToggleAgent(toggleNode).toggleToggle();
};

var delegateClickToToggle = function delegateClickToToggle(event) {
  var node = event.target.closest('.flip__toggle');
  if (!node) return;

  if (!node.matches('.flip__toggle_link')) {
    event.preventDefault();
  }

  toggleToggle(node);
};

var delegateMouseOverToToggle = function delegateMouseOverToToggle(event) {
  if (!event.target) return;
  var node = event.target.closest('.flip__toggle_hover');
  if (!node) return;
  if (node.matches('.flip__toggle_active')) return;
  openToggle(node);
};

var handleOutsideClick = function handleOutsideClick(event) {
  var nodes = document.querySelectorAll('.flip.flip_closable.flip_active');

  _toConsumableArray(nodes).forEach(function (node) {
    return closeFlipByOutsideClick(node, event.target);
  });
};

var start = function start() {
  document.addEventListener('mouseover', delegateMouseOverToToggle);
  document.addEventListener('click', delegateClickToToggle);
  document.addEventListener('click', handleOutsideClick);
  document.addEventListener('touch', handleOutsideClick);
};

export default {
  closeFlipByOutsideClick: closeFlipByOutsideClick,
  toggleToggle: toggleToggle,
  start: start
};